import { collectParagraphElements, isParseError, parseXml } from "./xmlUtils";
import {
  extractRunsFromParagraph,
  type ParagraphRunsMeta,
} from "./textCore";

export type { ParagraphRunsMeta, RunMeta } from "./textCore";

export function parseDocumentParagraphRuns(xml: string): ParagraphRunsMeta[] {
  const doc = parseXml(xml);
  if (isParseError(doc)) return [];
  return collectParagraphElements(doc).map((pEl, index) =>
    extractRunsFromParagraph(pEl, index),
  );
}

export async function extractTextMetaFromDocx(
  arrayBuffer: ArrayBuffer,
): Promise<ParagraphRunsMeta[]> {
  const JSZip = (await import("jszip")).default;
  const zip = await JSZip.loadAsync(arrayBuffer);
  const xml = await zip.file("word/document.xml")?.async("text");
  if (!xml) return [];
  return parseDocumentParagraphRuns(xml);
}

export { runsHaveFormatting } from "./textCore";
